import { useState } from "react";
import { getOrderDetails } from "../services/orderService";
import OrderDetailsPopup from "./OrderDetailsPopup";

const OrderDetails = ({ orderId }) => {
  const [isBusy, setIsBusy] = useState(false);
  const [details, setDetails] = useState({});
  const [popup, setPopup] = useState(false);
  const showOrderDetails = async () => {
    const response = await getOrderDetails(orderId);
    if (response?.data?.code === 1) {
      setDetails(response?.data?.data);
      setPopup(true);
      setIsBusy(false);
    }
  };
  return (
    <>
      <button
        onClick={() => {
          setIsBusy(true);
          showOrderDetails();
        }}
        className="btn btn-sm badge bg-info-transparent ms-1 w-25 py-2"
        disabled={isBusy === true ? true : false}
      >
        {isBusy === true ? (
          <span
            className="spinner-border spinner-border-xs"
            role="status"
            aria-hidden="true"
          ></span>
        ) : (
          <>
            <i className="ri-list-check me-1 fw-medium align-middle d-none d-md-inline"></i>
            DETAILS
          </>
        )}
      </button>
      <OrderDetailsPopup order={details} popup={popup} setPopup={setPopup} />
    </>
  );
};

export default OrderDetails;
